<template>
  <v-container fluid>
    <Loading v-if="!loaded" :loading="true" />

    <v-alert v-else-if="accessDenied">
      {{ $t('errors.accessDenied') }}
    </v-alert>

    <div v-else>
      <v-row>
        <v-col>
          <SupportTicketCard
            :item="model.data"
            :metadata="model.metadata"
          />
        </v-col>
      </v-row>

      <!-- evaluation form - TEMPORARILY DISABLED -->
      <v-row v-if="false && model.data.closedOn && !model.data.evaluation.evaluatedById">
        <v-col>
          <v-card
            elevation="10"
            class="mx-auto my-12"
            max-width="800"
          >
            <v-toolbar
              color="purple"
              dark
            >
              <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
              <v-toolbar-title>
                {{ $t('supportTicketDetail.evaluation.title') }}
              </v-toolbar-title>
              <v-spacer />
              <!-- <v-icon>mdi-elevator</v-icon>  -->
            </v-toolbar>
            <v-spacer />
            <v-card-subtitle>
              {{ $t('supportTicketDetail.evaluation.subtitle') }}
            </v-card-subtitle>
            <v-card-text>
              <v-row
                v-for="(question,i) in model.data.evaluation.questions"
                :key="i"
              >
                <v-col cols="4">
                  {{ question.text }}
                </v-col>
                <v-col cols="4">
                  <v-slider
                    v-model="question.response"
                    color="purple"
                    thumb-label="always"
                    :max="question.scoreMax"
                    :min="question.scoreMin"
                    step="1"
                  />
                </v-col>
                <v-col cols="4">
                  {{ $t('supportTicketDetail.evaluation.description', { min: question.scoreMin, max: question.scoreMax }) }}
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="model.data.evaluation.comment"
                    :label="$t('supportTicketDetail.evaluation.comment')"
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col align="right">
                  <v-btn
                    dark
                    color="purple"
                    @click="evaluate"
                  >
                    {{ $t('supportTicketDetail.evaluation.save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <!-- evaluate show form -->
      <v-row v-if="false && model.data.closedOn && !!model.data.evaluation.evaluatedById">
        <v-col>
          <v-card elevation="2">
            <v-card-title>
              {{ $t('supportTicketDetail.evaluation.title') }}
            </v-card-title>
            <v-card-text>
              <v-row
                v-for="(question,i) in model.data.evaluation.questions"
                :key="i"
              >
                <v-col cols="4">
                  {{ question.text }}
                </v-col>
                <v-col cols="4">
                  <v-slider
                    v-model="question.response"
                    thumb-label="always"
                    :max="question.scoreMax"
                    readonly
                    :min="question.scoreMin"
                    step="1"
                  />
                </v-col>
                <v-col cols="4">
                  {{ $t('supportTicketDetail.evaluation.description', { min: question.scoreMin, max: question.scoreMax }) }}
                </v-col>
              </v-row>
              <v-row>
                {{ $t('supportTicketDetail.evaluation.comment') }}:<br>
                {{ model.data.evaluation.comment }}
              </v-row>
              <v-row>
                {{ $t('supportTicketDetail.evaluation.sentBy', { name: model.data.evaluation.evaluatedByFullNameWithDetails, timestamp: $options.filters.formatDateTime(model.data.evaluation.evaluatedOn) }) }}
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Sagsoplysninger -->
      <v-row>
        <v-col>
          <v-card elevation="2">
            <v-toolbar flat>
              <v-toolbar-title>
                {{ $t('supportTicketDetail.info.title') }}
              </v-toolbar-title>

              <v-spacer />

              <div>
                <SupportTicketEditDialog
                  v-if="user.organizationKind == 'Internal'"
                  @saved="init"
                />
              </div>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-simple-table>
                    <template #default>
                      <tbody>
                        <tr>
                          <th>
                            {{ $tc('common.location') }}
                          </th>
                          <td class="text-right">
                            <LocationLink :id="model.data.locationId" />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketDetail.info.number') }}
                          </th>
                          <td class="text-right">
                            {{ model.data.code }}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketCreate.externalReference') }}
                          </th>
                          <td class="text-right">
                            {{ model.data.externalCode }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-simple-table>
                    <template #default>
                      <tbody>
                        <tr>
                          <th class="d-flex align-center">
                            <v-icon>mdi-account-outline</v-icon>
                            {{ $t('common.calledBy') }}
                          </th>
                          <td class="text-caption">
                            {{ model.data.calledByFullName }} ({{ model.data.calledByOrganizationTitle }}, {{ model.data.calledByTitle }})
                          </td>
                          <td class="text-right">
                            <SupportTicketDialogCalledBy
                              v-if="!model.data.closedOn && (user.id == model.data.calledById || user.permissions.includes('AdministratorSupportTicket'))"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th class="d-flex align-center">
                            <v-icon>mdi-account-outline</v-icon>
                            {{ $t('common.currentAssigned') }}
                          </th>
                          <td class="text-caption">
                            {{ model.data.assignedToFullName }} ({{ model.data.assignedToOrganizationTitle }})
                          </td>
                          <td class="text-right">
                            <SupportTicketDialogAssignedTo
                              v-if="!model.data.closedOn && (user.id == model.data.assignedToId || user.permissions.includes('AdministratorSupportTicket'))"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th class="d-flex align-center">
                            <v-icon>
                              mdi-account-multiple-outline
                            </v-icon>
                            <span>
                              {{ $tc('common.follower', 2) }}
                            </span>
                          </th>
                          <td>
                            <div
                              v-for="item in model.data.followerPersons"
                              :key="item.id"
                              class="text-caption"
                            >
                              {{ item.fullNameWithDetails }}
                            </div>
                            <div
                              v-for="item in model.data.followerDepartments"
                              :key="item.id"
                              class="text-caption"
                            >
                              {{ item.title }}
                            </div>
                          </td>
                          <td class="text-right">
                            <SupportTicketDialogFollowers
                              v-if="!model.data.closedOn"
                              @saved="init"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-simple-table>
                    <template #default>
                      <tbody>
                        <tr>
                          <th>
                            {{ $t('common.onHold') }}
                          </th>
                          <td class="text-right">
                            <span v-if="model.data.awaitingCustomer">
                              {{ $t('supportTicketDetail.info.awaitingCustomer') }}
                            </span>
                            <SupportTicketDialogWaiting
                              v-if="user.organizationKind == 'Internal' && !model.data.closedOn && (user.id == model.data.calledById || user.id == model.data.assignedToId || user.permissions.includes('AdministratorSupportTicket'))"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketDetail.info.registered') }}
                          </th>
                          <td class="text-right">{{ model.data.createdOn | formatDateTime }}</td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketDetail.info.inspected') }}
                          </th>
                          <td class="text-right">
                            {{ model.data.referredOn | formatDateTime }}
                            <SupportTicketDialogReferredOn
                              v-if="user.organizationKind == 'Internal' && !model.data.referredOn && !model.data.closedOn"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketDetail.info.workStart') }}
                          </th>
                          <td class="text-right">
                            {{ model.data.startedOn | formatDateTime }}
                            <SupportTicketDialogStartedOn
                              v-if="user.organizationKind == 'Internal' && model.data.referredOn && !model.data.startedOn && !model.data.closedOn"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('supportTicketDetail.info.workEnd') }}
                          </th>
                          <td class="text-right">
                            {{ model.data.endedOn | formatDateTime }}
                            <SupportTicketDialogEndedOn
                              v-if="user.organizationKind == 'Internal' && model.data.startedOn && !model.data.endedOn && !model.data.closedOn"
                              @saved="init"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ $t('common.finished') }}
                          </th>
                          <td class="text-right">
                            <SupportTicketDialogReopen
                              v-if="model.data.closedOn"
                              @saved="init"
                            />
                            <SupportTicketDialogClose
                              v-if="!model.data.closedOn"
                              @saved="init"
                            />
                            <span class="ml-2">
                              {{ model.data.closedOn | formatDateTime }}
                            </span>
                          </td>
                        </tr>
                        <tr v-if="model.data.closeCreatedTaskRequestId">
                          <th>
                            {{ $t('supportTicketDetail.info.movedToTaskRequest') }}:
                          </th>
                          <td class="text-right">
                            <router-link :to="`/taskrequest/${model.data.closeCreatedTaskRequestId}`">
                              {{ model.data.closeCreatedTaskRequestCodeAndTitle }}
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          xs="12"
          sm="12"
          md="12"
          lg="6"
        >
          <v-card elevation="2">
            <v-toolbar flat>
              <v-toolbar-title>
                {{ $t('supportTicketDetail.details.title') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <!-- overveje at bruge https://vuetifyjs.com/en/components/dividers/#subheaders -->
              <b>{{ model.data.title }}</b>
              <div v-html="model.data.text" />
              <div
                v-if="model.data.contactDetails"
                v-html="model.data.contactDetails"
                class="mt-2"
              />
            </v-card-text>
          </v-card>
          <v-card
            elevation="2"
            class="mt-6"
          >
            <v-toolbar flat>
              <v-toolbar-title>
                {{ $t('supportTicketDetail.files.title') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <FileList
                base-url="/supportticket/file"
                :files="model.data.files"
                :deletable="user.id == model.data.calledById || user.id == model.data.assignedToId || user.permissions.includes('AdministratorSupportTicket')"
              />

              <v-file-input
                v-model="newFiles"
                counter
                multiple
                show-size
                truncate-length="25"
                accept=".doc,.docx,application/msword,image/*,application/pdf,.pdf"
              /> <!-- hvilke filtyper? -->
              <div align="right">
                <v-btn
                  outlined
                  :disabled="newFiles.length==0"
                  @click="filesAdd"
                >
                  {{ $t('supportTicketDetail.files.upload') }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          xs="12"
          sm="12"
          md="12"
          lg="6"
        >
          <ActivityLog
            :add-endpoint="`/SupportTicket/${$route.params.id}/Entry`"
            :entry-template="model.data.entryTemplate"
            :entries="model.data.entries"
            :closed="!!model.data.closedOn"
            :relationId="$route.params.id"
            relationKind="SupportTicket"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import FileList from '@/components/FileList';
import LocationLink from '@/components/LocationLink.vue'
import SupportTicketCard from '@/components/support-ticket/SupportTicketCard'
import SupportTicketDialogCalledBy from '@/components/support-ticket/SupportTicketDialogCalledBy.vue'
import SupportTicketDialogAssignedTo from '@/components/support-ticket/SupportTicketDialogAssignedTo.vue'
import SupportTicketDialogWaiting from '@/components/support-ticket/SupportTicketDialogWaiting.vue'
import SupportTicketDialogReopen from '@/components/support-ticket/SupportTicketDialogReopen.vue'
import SupportTicketDialogClose from '@/components/support-ticket/SupportTicketDialogClose.vue'
import SupportTicketDialogFollowers from '@/components/support-ticket/SupportTicketDialogFollowers.vue'
import SupportTicketDialogReferredOn from '@/components/support-ticket/SupportTicketDialogReferredOn.vue'
import SupportTicketDialogStartedOn from '@/components/support-ticket/SupportTicketDialogStartedOn.vue'
import SupportTicketDialogEndedOn from '@/components/support-ticket/SupportTicketDialogEndedOn.vue'
import SupportTicketEditDialog from '@/components/support-ticket/SupportTicketEditDialog.vue'
import Loading from '@/components/Loading.vue'
import ActivityLog from '@/components/ActivityLog.vue';

export default {
  
  name: 'SupportTicketDetail',
  components: {
    FileList,
    LocationLink,
    SupportTicketCard,
    SupportTicketDialogCalledBy, 
    SupportTicketDialogAssignedTo, 
    SupportTicketDialogWaiting,
    SupportTicketDialogReopen,
    SupportTicketDialogClose,
    SupportTicketDialogFollowers,
    SupportTicketDialogReferredOn,
    SupportTicketDialogStartedOn,
    SupportTicketDialogEndedOn,
    SupportTicketEditDialog,
    Loading,
    ActivityLog
  },
  beforeRouteLeave(to, from, next) {
    if (this.model.data.entryTemplate.text !== '') {
      const answer = window.confirm(this.$t('feedback.confirmLeave'));

      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data() {
    return {
      model: Object,
      //view only data
      loaded: false,
      newFiles: [],
      accessDenied: false,
      timeProps: {
        format:"24hr",
        useSeconds: true,
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.currentUser;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init: async function() {
      try {
        const { data } = await this.$api.get(`supportticket/detail/${this.$route.params.id}`);

        if (data.success) {
          this.model = data.model;
        }

        else if (data.message === 'ERR_INCORRECT_CUSTOMER') {
          // If user has no other customer, display an error
          if (!this.$store.getters.userHasMultipleCustomers) {
            this.accessDenied = true;
            return;
          }

          // Try to find the correct customer ID
          const customerId = data.errors.find(x => this.isGuid(x.property))?.property;

          if (customerId) {
            this.$store.dispatch('setPrimaryCustomerId', customerId)
            this.init() // Calls itself. Be aware of inifite loop.
          }

          else {
            this.$store.dispatch('clearPrimaryCustomer');
          }
        }

        else {
          throw "Something happened";
        }
      } catch (error) {
        console.error(error)
        this.$notifier.showError({})
      } finally {
        this.loaded = true;
      }
    },
    evaluate: function() {
      this.$api.put(`supportticket/evaluate/${this.$route.params.id}`, this.model.data.evaluation).then(response => {
        if (response.data.success) {
          this.init();
        }
        else {
          //handle...
        }
      });
    },
    filesAdd() {      
      let formData = new FormData();

      for (let file of this.newFiles) {
          formData.append("files", file, file.name);
      }

      this.$api.post(`/SupportTicket/${vm.model.data.id}/Files`, formData, { headers: {'Content-Type': 'multipart/form-data'} }).then(response => {
        if (response.data.success) {
          this.model.data.files = response.data.model;
          this.newFiles = [];
        }
      });
    },
    fileRemove(id) {      
      if (!confirm(this.$t('feedback.confirmDelete'))) {
        return;
      }

      this.$api.delete(`/SupportTicket/File/${id}`).then(response => {
        if (response.data.success) {
          this.model.data.files = response.data.model;
        }
      });
    },
    
    addEntryKeyDown(e) {
      if (e.key==="Escape") {
        this.model.data.entryTemplate.text = '';
        this.model.data.entryTemplate.entryDateTime = null;
        this.model.data.entryTemplate.isInternal = false;
      }

      if ((e.key === "s" && e.altKey) || (e.keyCode === 13 && e.ctrlKey)) {
        e.preventDefault();
        this.addEntry();
      }
    },
    addEntry() {
      this.addingNote = true;

      if (!vm.model.data.entryTemplate.text)
        return;
      
      this.$api.post(`/SupportTicket/${vm.model.data.id}/Entry`, this.model.data.entryTemplate).then(response => {
        if (response.data.success) {
          this.model.data.entries.unshift(response.data.model);
          this.model.data.entryTemplate.text = '';
          this.model.data.entryTemplate.entryDateTime = null;
          this.model.data.entryTemplate.isInternal = false;
        }
      }).finally(() => {
        this.addingNote = false;
      });
    },

    isGuid(guid) {
      const regex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;
      return regex.test(guid);
    }
  },
  watch: {
    '$route.params.id': {
      handler: function() {
        this.init();
      }
    }
  }
}

</script>